// noinspection GraphQLUnresolvedReference

import { print } from 'graphql'

import { gqlAst } from '../../utils/gql.ts'

/**
 * Fragmento de campos de factura punto de venta
 * @author isi-template
 */
export const facturaPuntoVentaFragmentAst = /* GraphQL */ gqlAst`
  fragment facturaPuntoVentaFields on OrgFacturaPuntoVenta {
    codigo
    descripcion
    nombre
    tipoPuntoVenta {
      codigoClasificador
      descripcion
    }
  }
`

/**
 * Fragmento de campos de punto de venta
 * @author isi-template
 */
export const puntoVentaFragmentAst = /* GraphQL */ gqlAst`
  fragment puntoVentaFields on PuntoVenta {
    codigo
    descripcion
    nombre
    tipoPuntoVenta {
      codigoClasificador
      descripcion
    }
  }
`

/**
 * Fragmento de campos de factura punto de venta
 * @author isi-template
 */
export const facturaPuntoVentaFragment = print(facturaPuntoVentaFragmentAst)

/**
 * Fragmento de campos de punto de venta
 * @author isi-template
 */
export const puntoVentaFrament = print(puntoVentaFragmentAst)
